import chief from './../../assets/images/static/clientsIcons/chief.png';
import cod from './../../assets/images/static/clientsIcons/mrcod.png';
import cow from './../../assets/images/static/clientsIcons/cow-abunga.png';
import maheda from './../../assets/images/static/clientsIcons/maheda.png';
import salt from './../../assets/images/static/clientsIcons/salt.png';
import shahi from './../../assets/images/static/clientsIcons/shahi.png';
import khanpur from './../../assets/images/static/clientsIcons/khanpur.png';
import wakhan from './../../assets/images/static/clientsIcons/wakhan.png';

export const clients = [
  {
      id: 1,
      source: cod,
      title: 'Mr Cod'
  },
  {
    id: 2,
    source: salt,
    title: 'Salt Brothers'
  },
  {
    id: 3,
    source: cow,
    title: 'Cow Abunga'
  },
  {
    id: 4,
    source: khanpur,
    title: 'Khanpur Sweets and Bakers'
  },
  {
    id: 5,
    source: wakhan,
    title: 'WaKhan'
  },
  {
    id: 6,
    source: shahi,
    title: 'Shadi Dera'
  },
  {
    id: 7,
    source: chief,
    title: 'Chief'
  },
  {
    id: 8,
    source: maheda,
    title: 'Al Maheda'
  }
]
